
    import "src/app/AppAdmin/Billing/CODRemittance/index.module.scss?farm_css_modules";
    
    export default {"remittanceStatusFilter": `remittanceStatusFilter-1864385a`,"topRow": `topRow-1864385a`}
    